import { render, staticRenderFns } from "./customerAccounts.vue?vue&type=template&id=15565394&scoped=true&"
import script from "./customerAccounts.vue?vue&type=script&lang=js&"
export * from "./customerAccounts.vue?vue&type=script&lang=js&"
import style0 from "./customerAccounts.vue?vue&type=style&index=0&id=15565394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15565394",
  null
  
)

export default component.exports